import React from 'react';

import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectStyleByRecord } from 'PDF/helpers/documentStyle';

interface ISalesPlanHeaderProps {
  date: string[];
}

const colorIndexes = {
  green: 7,
  blue: 7,
  red: 7,
  blueGreen: 6,
  blueRed: 7,
  blueYellow: 7,
};

export const SalesPlanHeader: React.FC<ISalesPlanHeaderProps> = ({ date }) => (
  <View style={[styles.header, getColorObjectStyleByRecord(colorIndexes, 'backgroundColor')]} wrap={false}>
    {date.map((date, index) => (
      <View style={styles.ceil} key={index}>
        <Text style={styles.headerText}>{date}</Text>
      </View>
    ))}
  </View>
);

const styles = StyleSheet.create({
  header: {
    display: 'flex',
    flexDirection: 'row',
    padding: '0 4px',
    width: '100%',
    height: '16px',
    paddingLeft: '158px',
  },
  ceil: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    fontFamily: 'Noto',
    fontWeight: 700,
    fontSize: 9,
    color: '#fff',
    marginLeft: 'auto',
  },
});
